import React from "react";
import { render } from "react-dom";
import Modal from "react-modal";
import { HashRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import initLogger from "@helpers/logging";

import { App } from "./App";
import "./i18n";

initLogger();

// Bind react-modal to the app root once so modals can hide background content
// from assistive technologies (aria-hidden) without each modal disabling it.
Modal.setAppElement("#root");
render(
    <React.StrictMode>
        <HashRouter>
            <App />
        </HashRouter>
        <ToastContainer />
    </React.StrictMode>,
    document.getElementById("root")
);
